customElements.define('component-returns-form', class ReturnsForm extends HTMLElement {
  constructor() {
    super();
    this.emailInput = this.querySelector('#emailInput');
    this.orderIdInput = this.querySelector('#orderIdInput');
    this.submitButton = this.querySelector('#submitButton');
    this.errorMessage = this.querySelector('#errorMessage');
    this.returnsFormSection = this.querySelector('#returnsFormSection');

    this.submitButton.addEventListener('click', (event) => {
      event.preventDefault();
      if (!this.isValidForm()) {
        this.showErrorMessage(this.getErrorMessage());
        return;
      }
      let loopUrl = window.Shopify.shop.includes('trythirdlove') ? 'https://trythirdlove.loopreturns.com/' : 'https://thirdlove.loopreturns.com/';
      if (this.returnsFormSection.dataset.gma === "true") {
        loopUrl = this.returnsFormSection.dataset.loopGmaUrl || 'https://thirdlovegma.loopreturns.com/';
      }
      const redirectUrl = `${loopUrl}#/?email=${encodeURIComponent(this.emailInput.value)}&order=${encodeURIComponent(this.orderIdInput.value)}`;
      window.location.replace(redirectUrl);
    });
  }
  showErrorMessage(message) {
    this.errorMessage.innerHTML = message;
    this.errorMessage.style.visibility = 'visible';
  }
  isValidEmail(email) {
    if(this.returnsFormSection.dataset.validateEmail === "true") {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return email && re.test(email);
    }
    return true;
  }
  isValidForm() {
    return this.emailInput.value && this.orderIdInput.value
      && this.isValidEmail(this.emailInput.value);
  }
  getErrorMessage() {
    const email = this.emailInput.value;
    const orderId = this.orderIdInput.value;
    if (!email && !orderId) {
      this.emailInput.focus();
      return 'Please review the data entered.';
    }
    if (!email) {
      this.emailInput.focus();
      return 'Please complete all fields.';
    }
    if (!this.isValidEmail(email)) {
      this.emailInput.focus();
      return 'Some fields are not valid.';
    }
    if (!orderId) {
      this.orderIdInput.focus();
      return 'Enter an order number.';
    }
    return 'Something went wrong.';
  }
});
